import React from 'react';

import { ShopWithSwyftx } from '@swyftx/features/shop/components';

const Shop: React.FC = () => <ShopWithSwyftx />;

Shop.displayName = 'Shop';

export default Shop;
